export const addDataLayer=(params)=>{
    const {
        title, 
        productInfo = null,
        cart_ID = null,
        isOverlay = false,
        isFavorite = false,
        url = null,
        imageName = null,
        tileName = null,
        filterProps = null,
        resultLimit = null,
        searchProps = null,
        status = null,
        eventMsg = null
    } = params;
    const {adobeDataLayer:{getState}={}} = window;
    const page = getState && getState('page') || {};
    const componentName = `${page?.category?.subCategoryID}`;
    const eventType = (title === "add to compare" || title === "remove compare") ? "n/a" : "navigation";
    const productInfoJSON = (productInfo && productInfo.length > 0   // analytics data for productInfo
        ? { productInfo: JSON.parse(productInfo) }
        : null
    );
    const filterArrayJSON = (filterProps && filterProps.appliedFilters && (filterProps.appliedFilters).length > 0  // analytics data for filters
        ? { filterArray: filterProps?.appliedFilters }
        : null
    );
    const searchResultsJSON = ((searchProps && searchProps?.isSearch) // analytics data for search input box
        ? {
            searchTerm: searchProps?.searchTerm,
            searchResult: searchProps?.searchResult,
            searchCount: searchProps?.searchCount
        }
        : null
    );
    
    const image_Name = imageName ? imageName.replace(/-|_|--|__/g, " ") : "";

    cart_ID && (page.cart = {cartID: cart_ID});

    (searchProps && searchProps.searchCount) && sessionStorage.setItem("inspiration_searches", searchProps?.searchCount);

    let eventAction, internalLinkZoneName, internalLinkPosition, internalLinkName, internalLinkType, internalLinkURL;

    if(title === "inspiration image"){                            // datalayers for inspiration landing main content area
        internalLinkName = image_Name;
        internalLinkURL = (url && (`${url}`)) || "n/a";
    } else if(title === "sample navigation"){
        internalLinkName = tileName;
        internalLinkZoneName = `${componentName}:${isOverlay ? "inspiration detail overlay" : "inspiration image"}`;
        eventAction = `${internalLinkZoneName}:${title}`;
        internalLinkType = `${componentName}:${image_Name}`;
    } else if(isFavorite){
        internalLinkZoneName = `${componentName}:${isOverlay ? "inspiration detail overlay" : "inspiration image"}`;
        eventAction = `${internalLinkZoneName}:${title}`;
        internalLinkType = `${componentName}:${image_Name}`;
    } else if(title === "load more" || title === "back to top"){
        internalLinkType = `${componentName}:navigation`;
    } else if(title === "bottom pagination"){
        internalLinkName = `view ${resultLimit}`,
        internalLinkType = `${componentName}:pagination`;
    } else if (filterProps?.isFilter){                                         // datalayers for filters
        internalLinkZoneName = `${componentName}:filters`;
        eventAction = `${internalLinkZoneName}:${title}`;
        if(title === "accordion expand" || title === "accordion collapse"){
            internalLinkType = `${componentName}:${filterProps?.facetName}`;
        } else if(title === "show filters" || title === "hide filters"){
            internalLinkType = `${internalLinkZoneName}`;
        } else if(title === "filter canceled"){
            internalLinkName = `${filterProps?.filterName}:canceled`;
            internalLinkType = `${componentName}:${filterProps?.facetName}`;
        } else if(title === "view all" || title === "view less"){
            internalLinkType = `${componentName}:collection`;
        } else if(title === "show more filters" || title === "show less filters"){
            internalLinkType = `${internalLinkZoneName}`;
        } else if(title === "filter removed" || title === "filter applied"){
            const isRemoved = (title === "filter removed") ? true : false;
            internalLinkName = `${filterProps?.filterName}:${isRemoved ? "removed" : "applied"}`;
            internalLinkType = `${componentName}:${filterProps?.facetName}`;
        }
    } else if(searchProps?.isSearch){                                // datalayers for search input box
        internalLinkZoneName = `${componentName}:search box`;
        eventAction = `${internalLinkZoneName}:${title}`;
    } else if(isOverlay){
        internalLinkZoneName = `${componentName}:inspiration detail overlay`;
        eventAction = `${internalLinkZoneName}:${title}`;
        internalLinkType = `${componentName}:${image_Name}`;
        if(title === "custom order sample image"){
            internalLinkName = `${image_Name}`;
            internalLinkType = `${componentName}:custom order sample`;
            internalLinkURL = (url && (`${url}`)) || "n/a";
        }
    }

    const eventInfo = {
        eventAction: eventAction || `${componentName}:main content area:${title}`,
        eventName: eventAction || `${componentName}:main content area:${title}`,
        eventType: eventType,
        eventMsg: eventMsg || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: internalLinkName || `${title}`,
        internalLinkPosition: internalLinkPosition || `${componentName}`,
        internalLinkType: internalLinkType || `${componentName}:${title}`,
        internalLinkZoneName: internalLinkZoneName || `${componentName}:main content area`,
        internalLinkURL: internalLinkURL || (url && (`${window.location.origin + url}`) || "n/a"),
        clickInternalLinks: "true",
        ...searchResultsJSON,
        ...filterArrayJSON
    }

    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        ...productInfoJSON
    })
}

export const getSocialAnalyticsData=(params)=>{
    const { 
        title, 
        isOverlay = false,
        isFilter =false,
        imageName = null, 
    } = params;
    const {adobeDataLayer:{getState}={}} = window;
    const page = getState && getState('page') || {};
    const componentName = `${page?.category?.subCategoryID}`;
    const image_Name = imageName ? imageName.replace(/-|_|--|__/g, " ") : "";
    let eventAction, internalLinkType, internalLinkZoneName;

    if(isFilter){                                            // datalayers for filters
        internalLinkZoneName = `${componentName}:filters`;
        eventAction = `${internalLinkZoneName}:${title}`;
        internalLinkType = `${componentName}:${title}`;
    }
    
    const analyticsData = {
        eventAction: eventAction || `${componentName}:${isOverlay ? "inspiration detail overlay" : "inspiration image"}:${title}`, 
        eventName: eventAction || `${componentName}:${isOverlay ? "inspiration detail overlay" : "inspiration image"}:${title}`,
        internalLinkPosition: `${componentName}`, 
        internalLinkType: internalLinkType || `${componentName}:${image_Name}`, 
        internalLinkZoneName: internalLinkZoneName || `${componentName}:${isOverlay ? "inspiration detail overlay" : "inspiration image"}`,
    }
    return JSON.stringify(analyticsData)
}